





import { Vue, Component } from "vue-property-decorator";
import Configurator from "@/views/Configurator.vue";
import Recap from "@/views/Recap.vue";
import { routingStore } from "@/store/typed";

@Component({
  components: {
    Configurator,
    Recap
  },
})
export default class Home extends Vue {
  get configurator() {
    return routingStore.configuratorRoute;
  }

  get recap() {
    return routingStore.recapRoute;
  }

}
